module.exports = "/images/phone.png?0528599a0287d2cc3349a0952bbd5ecb";